import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './Confg/UserContext';
import { OrdersProvider } from './Confg/OrdersContext';
import { RestauranteProvider } from './Confg/RestauranteContext';
import { TourProvider } from './Confg/TourContext';
import { loadAppConfig } from './Confg/appConfig';

// URLs da API e do suporte vêm do Firestore (settings/appConfig) com cache local —
// semeia antes do primeiro render pra nenhuma chamada sair com URL vazia.
loadAppConfig();

// Suprime logs de debug em produção para não vazar dados de pedidos/usuários
if (process.env.NODE_ENV === 'production') {
  /* eslint-disable no-console */
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  /* eslint-enable no-console */
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <UserProvider>
        <OrdersProvider>
          <RestauranteProvider>
            <TourProvider>
              <App />
            </TourProvider>
          </RestauranteProvider>
        </OrdersProvider>
      </UserProvider>
    </BrowserRouter>
  </React.StrictMode>
);
